module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAoCAYAAAD+MdrbAAAAt0lEQVRIia3WyQ3DMAxE0R8hFaRVt2G5zLSRXKLAiyRzmQEIkJcH8sbHm9cCVEQpwPIrGYgSLbtegpbTnEbPYBrtgSl0BIbRGRhC70A3agFdqBU0ox7QhHrBWzQCTtEoOEQzYBfNghdUAR7QpwhsqGzDlo8SXIFNBa7ABpqT/5gCPGBZ8IJlwC4WBYdYBKwzzAtWDE+VFTRhVtCMWUAXdge6sRkYwkZgGOuBKewMprE9KMEaKMMAvjWXKNdfDMz8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar-button.png
// module id = 15Jc
// module chunks = 1